import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HowToRegIcon(props: IconProps) {
    return <Icon {...props} iconKey={"how_to_reg"}/>
}
